export class Vec3D {
    constructor(x = 0, y = 0, z = 0) {
        this.x = x;
        this.y = y;
        this.z = z;
    }
    clone() {
        return new Vec3D(this.x, this.y, this.z);
    }
    dimValue(n) {
        switch (n) {
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
        }
        throw new Error();
    }
    setDimValue(n, v) {
        switch (n) {
            case 0:
                this.x = v;
                return;
            case 1:
                this.y = v;
                return;
            case 2:
                this.z = v;
                return;
        }
        throw new Error();
    }
    set(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
    }
    iadd(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    imin(v) {
        if (v.x < this.x)
            this.x = v.x;
        if (v.y < this.y)
            this.y = v.y;
        if (v.z < this.z)
            this.z = v.z;
        return this;
    }
    imax(v) {
        if (v.x > this.x)
            this.x = v.x;
        if (v.y > this.y)
            this.y = v.y;
        if (v.z > this.z)
            this.z = v.z;
        return this;
    }
    add(v) {
        return new Vec3D(this.x + v.x, this.y + v.y, this.z + v.z);
    }
    rotY(rad) {
        const cos = Math.cos(rad);
        const sin = Math.sin(rad);
        return new Vec3D(this.x * cos - this.z * sin, this.y, this.x * sin + this.z * cos);
    }
    sub(v) {
        return new Vec3D(this.x - v.x, this.y - v.y, this.z - v.z);
    }
    mul(s) {
        return new Vec3D(this.x * s, this.y * s, this.z * s);
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
}
